import React from 'react';
import DetailPage from '../../components/DetailPage';

export default function OfficeAutomation() {
  return <DetailPage type="product" id="office-automation" />;
}
